<div class="dialog addToCollection">
    @if (user) {
        <div class="dialog-title">
            <h2 mat-dialog-title>
               {{'editProfile.hl' | translate}}
            </h2>
            <button mat-icon-button (click)="close()">
                <mat-icon  fontIcon="close"></mat-icon>
            </button>
        </div>
        <mat-dialog-content>
            <form [formGroup]="userForm">
                <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                                <mat-label>{{'editProfile.firstName'| translate}}</mat-label>
                                <input matInput  formControlName="firstName" aria-describedby="firstNameRequired">
                            </mat-form-field>
                            @if(userForm.controls['firstName'].invalid && (userForm.get('firstName')?.touched || userForm.controls['firstName'].dirty)) {
                                @if(userForm.controls['firstName'].hasError('required')) {
                                    <div class="error" id="firstNameRequired" role="alert">{{'error.required' | translate}}</div>
                                }
                            }
                        </div>
                    </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>{{'editProfile.lastName'| translate}}</mat-label>
                            <input matInput  formControlName="lastName" aria-describedby="lastNameRequired">
                        </mat-form-field>
                        @if(userForm.controls['lastName'].invalid && (userForm.get('lastName')?.touched || userForm.controls['lastName'].dirty)) {
                            @if(userForm.controls['lastName'].hasError('required')) {
                                <div class="error" id="lastNameRequired" role="alert">{{'error.required' | translate}}</div>
                            }
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>{{'editProfile.jobTitle'| translate}}</mat-label>
                            <input matInput  formControlName="jobTitle">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>{{'editProfile.company' | translate}}</mat-label>
                            <input matInput  formControlName="company">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>{{'editProfile.department'| translate}}</mat-label>
                            <input matInput  formControlName="department">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>{{'editProfile.country'| translate}}</mat-label>
                            <mat-select formControlName="country">
                                @for(c of countries | keyvalue; track c ) {
                                    <mat-option [value]="c.key">{{c.value}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">

                        <div class="role-wrapper">
                            <h3>{{'user.roles' | translate}}</h3>
                            @for(entry of user.roles; track entry; let last = $last) {
                                <span class="role">{{entry}}</span>
                                @if(!last) {
                                    <span>, </span>
                                }
                            }
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="btn-row">
                            <button mat-button type="button" (click)="close()">{{'button.cancel'|translate}}</button>
                            <button mat-raised-button type="submit" (click)="save()"
                                    [disabled]="!userForm.valid">{{'button.save'|translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </mat-dialog-content>
    }
</div>
